<div [formGroup]="formGroup">
    <dff-form-control [formControl]="formGroup.get('vaerdi.aktuel')" maxlength="50"></dff-form-control>
</div>